import useGoBack from 'utilities/navigation/back'
import { Form, Formik } from 'formik'
import Header from 'components/headers/addLoan'
import AddNewIcon from 'assets/images/loans/managementAddNew.svg'
import { useState } from 'react'
import useSetData from '../../addNewFinal/hooks/useSetData'
import CustomDatePicker from 'components/datePicker'
import moment from 'jalali-moment'
import { ConvertorMiladi } from 'utilities/helper/digitToMonth'
import EditIcon from 'assets/images/loans/edit.svg'
import Num2persian from 'utilities/helper/num2Persian'
import DotsLoading from 'components/loadings/dotsLoading'
import useValidateInstallments from '../hooks/useValidateInstallments'
import { NumericFormat } from 'react-number-format'

export default function StepTwo() {
    const [data, setData] = useState<
        undefined | Array<IManagementAddNewLoanExtends>
    >()
    const goBack = useGoBack()
    const { mutate } = useValidateInstallments()
    const {
        handleSelect,
        amount,
        setAmount,
        date,
        setDate,
        handleSetSelect,
        handleMutate,
    } = useSetData(data, setData, mutate)
    return (
        <>
            <Formik
                initialValues={
                    {
                        // amount: '',
                        // tag: '',
                        // number: '',
                        // fee_type: '',
                        // date: '',
                    }
                }
                onSubmit={(values) => {}}
            >
                {({ values, touched, errors, setFieldValue }) => (
                    <Form>
                        <div className=" mx-3 flex flex-col h-screen text-sm ">
                            <div className=" grow-0">
                                <Header title="اعطای وام" />
                            </div>
                            <div className=" rounded-lg grow">
                                <div className="  bg-white  mt-14 rounded-lg relative py-4 shadow-[0px_2px_6px_-1px_rgba(0,0,0,0.1),0px_1px_0px_0px_rgba(25,28,33,0.02),0px_0px_0px_1px_rgba(25,28,33,0.08)]">
                                    <div className=" text-center mt-4">
                                        <img
                                            src={AddNewIcon}
                                            alt="add-loan"
                                            className=" absolute right-[35%] md:right-1/2 md:translate-x-1/2 -top-14"
                                        />
                                    </div>
                                    <div className=" px-4 h-96 overflow-y-scroll">
                                        {data ? (
                                            data.map((item) => (
                                                <div
                                                    className=" my-2"
                                                    key={item.index}
                                                    onClick={() =>
                                                        handleSelect(item.index)
                                                    }
                                                >
                                                    <p className=" text-gray-3">
                                                        قسط {item.index}
                                                    </p>
                                                    <div>
                                                        <div className="flex justify-between items-center">
                                                            {item.isSelected ? (
                                                                <div
                                                                    className=" rounded-full flex flex-col"
                                                                    onClick={(
                                                                        e
                                                                    ) =>
                                                                        e.stopPropagation()
                                                                    }
                                                                >
                                                                    <NumericFormat
                                                                        thousandSeparator
                                                                        allowNegative={
                                                                            false
                                                                        }
                                                                        name="amount"
                                                                        className=" outline-0 bg-gray-5 rounded-full px-2 py-1 ml-3"
                                                                        value={
                                                                            amount
                                                                        }
                                                                        onValueChange={(
                                                                            values
                                                                        ) => {
                                                                            const {
                                                                                value,
                                                                            } =
                                                                                values
                                                                            setAmount(
                                                                                //@ts-ignore
                                                                                value
                                                                            )
                                                                        }}
                                                                    />
                                                                </div>
                                                            ) : (
                                                                <p>
                                                                    {item.amount &&
                                                                        item.amount.toLocaleString()}{' '}
                                                                    تومان
                                                                </p>
                                                            )}
                                                            {item.isSelected ? (
                                                                <div
                                                                    dir="rtl"
                                                                    className=" bg-gray-5 rounded-full px-2 py-0.5 flex flex-col ml-1 w-full"
                                                                    onClick={(
                                                                        e
                                                                    ) =>
                                                                        e.stopPropagation()
                                                                    }
                                                                >
                                                                    <CustomDatePicker
                                                                        isEdit
                                                                        setValue={(
                                                                            e: string
                                                                        ) => {
                                                                            setDate(
                                                                                e
                                                                            )
                                                                        }}
                                                                        name={
                                                                            ''
                                                                        }
                                                                        value={moment
                                                                            .from(
                                                                                date
                                                                                    ? date
                                                                                    : item.due_date,
                                                                                'YYYY-MM-DD'
                                                                            )
                                                                            .locale(
                                                                                'fa'
                                                                            )
                                                                            .format(
                                                                                'YYYY/MM/DD'
                                                                            )}
                                                                        title=""
                                                                        placeHolder=""
                                                                    />
                                                                </div>
                                                            ) : (
                                                                <p>
                                                                    {ConvertorMiladi(
                                                                        item.due_date
                                                                    )}
                                                                </p>
                                                            )}
                                                            <div>
                                                                {item.isSelected ? (
                                                                    <p
                                                                        className=" text-green-1"
                                                                        onClick={(
                                                                            e
                                                                        ) => {
                                                                            e.stopPropagation()
                                                                            handleSetSelect(
                                                                                item.index
                                                                            )
                                                                        }}
                                                                    >
                                                                        اعمال
                                                                    </p>
                                                                ) : (
                                                                    <img
                                                                        src={
                                                                            EditIcon
                                                                        }
                                                                        alt="edit"
                                                                        className=" w-4 h-4"
                                                                    />
                                                                )}
                                                            </div>
                                                        </div>
                                                        {item.isSelected &&
                                                            amount && (
                                                                <span className=" text-xs text-blue-1 text-center w-full">
                                                                    {Num2persian(
                                                                        amount.toString()
                                                                    )}{' '}
                                                                    تومان
                                                                </span>
                                                            )}
                                                    </div>
                                                    <hr className=" my-2" />
                                                </div>
                                            ))
                                        ) : (
                                            <DotsLoading />
                                        )}
                                    </div>
                                </div>
                            </div>
                            <button
                                className=" grow-0 bg-green-1 text-white py-3 rounded-lg"
                                type="submit"
                                onClick={() => handleMutate()}
                            >
                                انتقال وام
                            </button>
                            <button
                                type="button"
                                className=" text-center my-3 text-gray-4"
                                onClick={goBack}
                            >
                                بازگشت
                            </button>
                        </div>
                    </Form>
                )}
            </Formik>
        </>
    )
}
